  (function() {
    var root = document.querySelector('.amazon-product[data-section-id]');
    if (!root) return;

    var AP_CFG = {};
    try {
      var cfgEl = document.querySelector('[data-ap-config]');
      if (cfgEl) AP_CFG = JSON.parse(cfgEl.textContent);
    } catch (error) {
      AP_CFG = {};
    }
    var AP_STRINGS = AP_CFG.strings || {};

    var thumbs = root.querySelectorAll('[data-ap-thumb]');
    var mediaItems = root.querySelectorAll('[data-ap-main-media]');
    var variantSelect = root.querySelector('.ap-variant-select');
    var hiddenVariant = root.querySelector('[data-ap-hidden-variant]');
    var optionButtons = root.querySelectorAll('[data-ap-option-button]');
    var optionLabels = root.querySelectorAll('[data-ap-selected-option]');
    var addButton = root.querySelector('[data-ap-add-button]');
    var addText = root.querySelector('[data-ap-add-text]');
    var priceEls = root.querySelectorAll('[data-ap-price], [data-ap-price-copy]');
    var compareWrap = root.querySelector('[data-ap-compare-wrap]');
    var compareEl = root.querySelector('[data-ap-compare]');
    var saveWrap = root.querySelector('[data-ap-save-wrap]');
    var saveEl = root.querySelector('[data-ap-save]');
    var discountEl = root.querySelector('[data-ap-discount]');
    var stockEls = root.querySelectorAll('[data-ap-stock], [data-ap-buy-stock]');
    var skuWrap = root.querySelector('[data-ap-sku-wrap]');
    var skuEls = root.querySelectorAll('[data-ap-sku]');
    var dealBadge = root.querySelector('[data-ap-deal-badge]');
    var mediaWrap = root.querySelector('.ap-main-media-wrap');
    var thumbnailRail = root.querySelector('.ap-thumbnail-rail');
    var mediaPrevButton = root.querySelector('[data-ap-media-prev]');
    var mediaNextButton = root.querySelector('[data-ap-media-next]');
    var nativeShareButtons = root.querySelectorAll('[data-ap-native-share]');
    var zoomOpenButton = root.querySelector('[data-ap-zoom-open]');
    var zoomDialog = root.querySelector('[data-ap-zoom-dialog]');
    var zoomCloseButton = root.querySelector('[data-ap-zoom-close]');
    var zoomPrevButton = root.querySelector('[data-ap-zoom-prev]');
    var zoomNextButton = root.querySelector('[data-ap-zoom-next]');
    var zoomItems = root.querySelectorAll('[data-ap-zoom-media]');
    var noPhotoMedia = root.querySelector('[data-ap-no-photo-media]');
    var noPhotoMediaId = noPhotoMedia ? noPhotoMedia.getAttribute('data-ap-main-media') : '';
    var noPhotoLabelEls = root.querySelectorAll('[data-ap-no-photo-label]');
    var quantityInput = root.querySelector('[data-ap-quantity-input]');
    var quantityMinusButton = root.querySelector('[data-ap-quantity-minus]');
    var quantityPlusButton = root.querySelector('[data-ap-quantity-plus]');
    var productForm = root.querySelector('.ap-product-form form');
    var buyBox = root.querySelector('.ap-buy-box');
    var infoColumn = root.querySelector('.ap-info-column');
    var formErrorWrap = root.querySelector('.ap-product-form .pform-error-wrap');
    var formErrorMsg = root.querySelector('.ap-product-form .pform-error-msg');
    var formSpinner = root.querySelector('.ap-product-form .loading-overlay__spinner');
    var coatConsultation = root.querySelector('[data-coat-consultation]');
    var coatWhatsAppLinks = root.querySelectorAll('[data-coat-whatsapp]');
    var coatFabricNote = root.querySelector('[data-coat-fabric-note]');
    var coatFabricMessages = root.querySelectorAll('[data-coat-fabric-message]');
    var formErrorFallback = AP_CFG.formErrorFallback || '';
    var optionCount = AP_CFG.optionCount || 0;
    var colorOptionPosition = AP_CFG.colorOptionPosition || 0;
    var sizeOptionPosition = AP_CFG.sizeOptionPosition || 0;
    var sizeChestRows = AP_CFG.sizeChestRows || '';
    var sizeChestTemplate = AP_CFG.sizeChestTemplate || '';
    var sizeChestEls = root.querySelectorAll('[data-ap-size-chest]');
    var selectedOptions = (AP_CFG.selectedOptions || []).slice();
    var variants = variantSelect ? Array.prototype.slice.call(variantSelect.options) : [];
    var touchStartX = null;
    var touchStartY = null;
    var mediaPinchStartDistance = 0;
    var mediaPinchOpened = false;
    var zoomTouchStartX = null;
    var zoomTouchStartY = null;
    var zoomPinchStartDistance = 0;
    var zoomScale = 1;
    var zoomStartScale = 1;
    var zoomTranslateX = 0;
    var zoomTranslateY = 0;
    var zoomStartTranslateX = 0;
    var zoomStartTranslateY = 0;
    var zoomDidPan = false;
    var mediaTapLast = 0;
    var zoomTapLast = 0;

    function mediaIndexFromOption(option) {
      var value = option ? option.getAttribute('data-media-index') : '';
      if (value === null || value === '') return null;
      return Number(value);
    }

    function getVariantOption(option, index) {
      return option.getAttribute('data-option' + (index + 1)) || '';
    }

    function getVariantOptions(option) {
      var values = [];
      for (var index = 0; index < optionCount; index += 1) {
        values.push(getVariantOption(option, index));
      }
      return values;
    }

    function normalizeSizeValue(value) {
      return String(value || '').trim().toLowerCase().replace(/\s+/g, '');
    }

    function buildSizeChestMap(rowsText) {
      var map = {};
      String(rowsText || '').split(/\r?\n/).forEach(function(row) {
        var parts = row.split('|');

        if (parts.length < 2) {
          parts = row.split(':');
        }

        if (parts.length < 2) return;

        var size = normalizeSizeValue(parts[0]);
        var chest = String(parts[1] || '').trim();

        if (size && chest) {
          map[size] = chest;
        }
      });
      return map;
    }

    var sizeChestMap = buildSizeChestMap(sizeChestRows);

    function updateSizeChestLabel() {
      if (!sizeOptionPosition || !sizeChestEls.length) return;

      var sizeValue = selectedOptions[sizeOptionPosition - 1] || '';
      var chestValue = sizeChestMap[normalizeSizeValue(sizeValue)] || '';

      sizeChestEls.forEach(function(el) {
        el.textContent = chestValue ? sizeChestTemplate.replace('[value]', chestValue) : '';
        el.hidden = !chestValue;
      });
    }

    function updateCoatSuitConsultation(selected) {
      if (!coatConsultation || !selected || !coatWhatsAppLinks.length) return;

      var phone = coatConsultation.getAttribute('data-whatsapp-phone') || '';
      var productTitle = coatConsultation.getAttribute('data-product-title') || '';
      var productPath = coatConsultation.getAttribute('data-product-path') || window.location.pathname;
      var fabricValue = coatConsultation.getAttribute('data-fabric-value') || '';
      var customValue = coatConsultation.getAttribute('data-custom-value') || '';
      var variantTitle = getVariantOptions(selected).filter(Boolean).join(' / ');
      var price = selected.getAttribute('data-price') || '';
      var productUrl = new URL(productPath, window.location.origin);
      productUrl.searchParams.set('variant', selected.value);

      coatWhatsAppLinks.forEach(function(link) {
        var action = link.getAttribute('data-coat-whatsapp');
        var promptAttribute = action === 'fitting' ? 'data-fitting-prompt' : 'data-purchase-prompt';
        var prompt = coatConsultation.getAttribute(promptAttribute) || '';
        var messageLines = [
          prompt,
          '',
          'Product: ' + productTitle,
          'Selected option: ' + variantTitle,
          'Price: ' + price,
          'Product link: ' + productUrl.toString()
        ];

        if (action === 'fitting') {
          messageLines.push(
            '',
            'Fabric option: ' + fabricValue,
            'Custom tailoring option: ' + customValue,
            'My chest size:',
            'My height:',
            'Wedding / event date:'
          );
        } else {
          messageLines.push('', 'Occasion:', 'Wedding / event date:');
        }

        link.href = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(messageLines.join('\n'));
      });

      if (coatFabricNote && (fabricValue || customValue)) {
        var assistanceSelected = selectedOptions.some(function(value) {
          var normalizedValue = String(value || '').trim().toLowerCase();
          return normalizedValue === String(fabricValue).trim().toLowerCase() ||
            normalizedValue === String(customValue).trim().toLowerCase();
        });
        coatFabricNote.classList.toggle('is-selected', assistanceSelected);
      }
    }

    function updateCoatFabricSelectionMessage() {
      if (!coatFabricMessages.length) return;

      coatFabricMessages.forEach(function(message) {
        var fabricValue = message.getAttribute('data-fabric-value') || '';
        var fabricSelected = selectedOptions.some(function(value) {
          return String(value || '').trim().toLowerCase() === String(fabricValue).trim().toLowerCase();
        });
        message.hidden = !fabricSelected;
      });
    }

    function isAvailable(option) {
      return option && option.getAttribute('data-available') === 'true';
    }

    function setStockState(element, state) {
      element.classList.remove('ap-stock-in', 'ap-stock-low', 'ap-stock-out');
      element.classList.add('ap-stock-' + state);
    }

    function setFormError(message) {
      if (!formErrorWrap || !formErrorMsg) return;
      formErrorMsg.textContent = message || '';
      formErrorWrap.toggleAttribute('hidden', !message);
    }

    function setAddButtonLoading(loading) {
      if (!addButton) return;
      addButton.classList.toggle('loading', loading);
      addButton.setAttribute('aria-disabled', loading ? 'true' : 'false');
      if (formSpinner) {
        formSpinner.classList.toggle('hidden', !loading);
      }
    }

    function syncGokwikBuyNowAvailability(available) {
      var gokwikBuyNow = root.querySelector('#gokwik-buy-now');
      if (!gokwikBuyNow) return;

      if (!available) {
        gokwikBuyNow.disabled = true;
        gokwikBuyNow.classList.add('disabled');
        gokwikBuyNow.setAttribute('data-ap-variant-disabled', 'true');
        return;
      }

      if (gokwikBuyNow.getAttribute('data-ap-variant-disabled') === 'true') {
        gokwikBuyNow.disabled = false;
        gokwikBuyNow.classList.remove('disabled');
        gokwikBuyNow.removeAttribute('data-ap-variant-disabled');
      }
    }

    function getCartDrawer() {
      return document.querySelector('cart-drawer');
    }

    function updateFreeShippingMessage() {
      if (typeof window.freeShippMsg === 'function') {
        window.freeShippMsg();
      }
    }

    function copyShareUrl(text) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
      }

      return new Promise(function(resolve, reject) {
        var input = document.createElement('textarea');
        input.value = text;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.top = '-1000px';
        document.body.appendChild(input);
        input.select();
        try {
          document.execCommand('copy');
          resolve();
        } catch (error) {
          reject(error);
        }
        document.body.removeChild(input);
      });
    }

    function shareProductPage(button) {
      var shareUrl = button.getAttribute('data-share-url') || window.location.href;
      var shareTitle = button.getAttribute('data-share-title') || document.title;

      if (navigator.share) {
        navigator.share({ title: shareTitle, url: shareUrl }).catch(function(error) {
          if (error && error.name === 'AbortError') return;
          copyShareUrl(shareUrl);
        });
        return;
      }

      copyShareUrl(shareUrl).then(function() {
        button.classList.add('is-copied');
        window.setTimeout(function() {
          button.classList.remove('is-copied');
        }, 1200);
      });
    }

    function clampQuantity() {
      if (!quantityInput) return 1;

      var min = Number(quantityInput.getAttribute('min')) || 1;
      var max = Number(quantityInput.getAttribute('max')) || 99;
      var value = parseInt(quantityInput.value, 10);

      if (Number.isNaN(value) || value < min) value = min;
      if (value > max) value = max;

      quantityInput.value = String(value);
      if (quantityMinusButton) quantityMinusButton.disabled = value <= min;
      if (quantityPlusButton) quantityPlusButton.disabled = value >= max;

      return value;
    }

    function changeQuantity(delta) {
      if (!quantityInput) return;
      var value = clampQuantity();
      quantityInput.value = String(value + delta);
      clampQuantity();
    }

    function syncFloatingControlsWithBuyPanel() {
      if (!buyBox || !('IntersectionObserver' in window)) return;

      var mobileQuery = window.matchMedia('(max-width: 860px)');
      var buyPanelVisible = false;

      function applyFloatingState() {
        document.body.classList.toggle('ap-buy-panel-visible', mobileQuery.matches && buyPanelVisible);
      }

      var observer = new IntersectionObserver(function(entries) {
        buyPanelVisible = entries.some(function(entry) {
          return entry.isIntersecting && entry.intersectionRatio > 0.08;
        });
        applyFloatingState();
      }, { threshold: [0, 0.08, 0.35] });

      observer.observe(buyBox);

      if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', applyFloatingState);
      } else if (typeof mobileQuery.addListener === 'function') {
        mobileQuery.addListener(applyFloatingState);
      }

      applyFloatingState();
    }

    function submitProductForm(event) {
      if (!productForm || !addButton) return;
      event.preventDefault();
      event.stopImmediatePropagation();

      if (addButton.disabled || addButton.getAttribute('aria-disabled') === 'true') return;

      clampQuantity();
      setFormError('');
      setAddButtonLoading(true);

      var body = new FormData(productForm);
      var cartDrawer = getCartDrawer();
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        body.append('sections', cartDrawer.getSectionsToRender().map(function(section) {
          return section.id;
        }));
        body.append('sections_url', window.location.pathname);
        if (typeof cartDrawer.setActiveElement === 'function') {
          cartDrawer.setActiveElement(document.activeElement);
        }
      }

      fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : productForm.action, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript'
        },
        body: body
      })
        .then(function(response) {
          return response.json();
        })
        .then(function(response) {
          if (response.status) {
            setFormError(response.description || formErrorFallback);
            return;
          }

          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(response);
          } else if (window.routes && window.routes.cart_url) {
            window.location.href = window.routes.cart_url;
          }
        })
        .catch(function() {
          setFormError(window.cartStrings && window.cartStrings.error ? window.cartStrings.error : formErrorFallback);
        })
        .finally(function() {
          setAddButtonLoading(false);
          updateFreeShippingMessage();
        });
    }

    function matchesOptions(option, options) {
      for (var index = 0; index < optionCount; index += 1) {
        if (options[index] && getVariantOption(option, index) !== options[index]) {
          return false;
        }
      }
      return true;
    }

    function findExactVariant(options) {
      return variants.find(function(option) {
        return matchesOptions(option, options);
      });
    }

    function findAvailableVariant(options, changedIndex) {
      var exact = findExactVariant(options);
      if (exact) return exact;

      var changedVariant = variants.find(function(option) {
        if (changedIndex < 0) return false;
        if (getVariantOption(option, changedIndex) !== options[changedIndex]) return false;

        if (colorOptionPosition > 0 && changedIndex !== colorOptionPosition - 1) {
          return getVariantOption(option, colorOptionPosition - 1) === options[colorOptionPosition - 1];
        }

        return true;
      }) || variants.find(function(option) {
        return changedIndex >= 0 && getVariantOption(option, changedIndex) === options[changedIndex];
      });

      if (changedVariant) return changedVariant;

      return variants.find(function(option) {
        if (!isAvailable(option)) return false;
        if (changedIndex >= 0 && getVariantOption(option, changedIndex) !== options[changedIndex]) return false;
        if (colorOptionPosition > 0) {
          return getVariantOption(option, colorOptionPosition - 1) === options[colorOptionPosition - 1];
        }
        return true;
      }) || variants.find(function(option) {
        if (!isAvailable(option)) return false;
        if (colorOptionPosition > 0) {
          return getVariantOption(option, colorOptionPosition - 1) === options[colorOptionPosition - 1];
        }
        return true;
      }) || variants.find(isAvailable) || exact || variants[0];
    }

    function getFirstVisibleMediaId() {
      var visibleThumb = Array.prototype.find.call(thumbs, function(thumb) {
        return !thumb.classList.contains('ap-media-hidden');
      });
      return visibleThumb ? visibleThumb.getAttribute('data-ap-thumb') : '';
    }

    function syncMediaFrame() {
      if (!mediaWrap) return;

      if (window.matchMedia && window.matchMedia('(max-width: 860px)').matches) {
        mediaWrap.style.removeProperty('--ap-media-frame-width');
        mediaWrap.style.removeProperty('--ap-media-frame-height');
        return;
      }

      var gallery = mediaWrap.closest('.ap-gallery');
      var availableWidth = mediaWrap.parentElement ? mediaWrap.parentElement.clientWidth : mediaWrap.clientWidth;
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 720;
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth || availableWidth;
      var isCompactTablet = viewportWidth <= 1280;
      var reservedHeight = isCompactTablet ? 132 : 44;
      var maxFrameHeight = Math.max(320, viewportHeight - reservedHeight);
      var frameRatio = 3 / 4;

      if (gallery) {
        var galleryStyle = window.getComputedStyle(gallery);
        var galleryColumns = galleryStyle.gridTemplateColumns.split(' ').filter(Boolean);
        var gap = parseFloat(galleryStyle.columnGap || galleryStyle.gap) || 0;

        if (galleryColumns.length > 1 && thumbnailRail) {
          availableWidth = Math.max(220, gallery.clientWidth - thumbnailRail.getBoundingClientRect().width - gap);
        } else {
          availableWidth = gallery.clientWidth || availableWidth;
        }
      }

      var frameWidth = Math.min(availableWidth || viewportWidth, maxFrameHeight * frameRatio);
      var frameHeight = frameWidth / frameRatio;

      mediaWrap.style.setProperty('--ap-media-frame-width', Math.floor(frameWidth) + 'px');
      mediaWrap.style.setProperty('--ap-media-frame-height', Math.floor(frameHeight) + 'px');
    }

    function queueMediaFrameSync() {
      window.requestAnimationFrame(syncMediaFrame);
    }

    function getVisibleThumbs() {
      return Array.prototype.filter.call(thumbs, function(thumb) {
        return !thumb.classList.contains('ap-media-hidden');
      });
    }

    function syncMediaControls() {
      var visibleThumbs = getVisibleThumbs();
      var hasMultipleMedia = visibleThumbs.length > 1;
      var activeNoPhoto = noPhotoMediaId && root.querySelector('[data-ap-main-media="' + noPhotoMediaId + '"].is-active');
      if (mediaPrevButton) mediaPrevButton.hidden = !hasMultipleMedia;
      if (mediaNextButton) mediaNextButton.hidden = !hasMultipleMedia;
      if (zoomOpenButton) zoomOpenButton.hidden = visibleThumbs.length === 0 || Boolean(activeNoPhoto);
      if (zoomPrevButton) zoomPrevButton.hidden = !hasMultipleMedia;
      if (zoomNextButton) zoomNextButton.hidden = !hasMultipleMedia;
    }

    function setMedia(mediaId) {
      var isNoPhotoTarget = noPhotoMediaId && mediaId === noPhotoMediaId;
      var targetThumb = !isNoPhotoTarget && mediaId ? root.querySelector('[data-ap-thumb="' + mediaId + '"]') : null;
      if (!isNoPhotoTarget && (!targetThumb || targetThumb.classList.contains('ap-media-hidden'))) {
        mediaId = getFirstVisibleMediaId();
      }
      if (!mediaId) {
        syncMediaControls();
        return;
      }
      thumbs.forEach(function(thumb) {
        thumb.classList.toggle('is-active', !isNoPhotoTarget && thumb.getAttribute('data-ap-thumb') === mediaId);
      });
      mediaItems.forEach(function(item) {
        item.classList.toggle('is-active', item.getAttribute('data-ap-main-media') === mediaId);
      });
      zoomScale = 1;
      zoomTranslateX = 0;
      zoomTranslateY = 0;
      zoomItems.forEach(function(item) {
        item.classList.toggle('is-active', item.getAttribute('data-ap-zoom-media') === mediaId);
        item.classList.remove('is-zoomed');
      });
      syncMediaControls();
      applyZoomTransform();
      queueMediaFrameSync();
    }

    function setRelativeMedia(direction) {
      var visibleThumbs = getVisibleThumbs();
      if (visibleThumbs.length < 2) return;

      var currentIndex = visibleThumbs.findIndex(function(thumb) {
        return thumb.classList.contains('is-active');
      });
      if (currentIndex < 0) currentIndex = 0;

      var nextIndex = (currentIndex + direction + visibleThumbs.length) % visibleThumbs.length;
      setMedia(visibleThumbs[nextIndex].getAttribute('data-ap-thumb'));
    }

    function getActiveZoomItem() {
      return Array.prototype.find.call(zoomItems, function(item) {
        return item.classList.contains('is-active');
      });
    }

    function getTouchDistance(touches) {
      if (!touches || touches.length < 2) return 0;
      var deltaX = touches[0].clientX - touches[1].clientX;
      var deltaY = touches[0].clientY - touches[1].clientY;
      return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    }

    function canZoomItem(item) {
      return Boolean(item && item.querySelector('.ap-zoom-image'));
    }

    function getActiveZoomImage() {
      var activeZoomItem = getActiveZoomItem();
      return canZoomItem(activeZoomItem) ? activeZoomItem.querySelector('.ap-zoom-image') : null;
    }

    function clampZoomScale(value) {
      return Math.max(1, Math.min(3.6, value));
    }

    function applyZoomTransform() {
      var activeZoomItem = getActiveZoomItem();
      var activeImage = getActiveZoomImage();

      zoomItems.forEach(function(item) {
        if (item !== activeZoomItem) {
          item.classList.remove('is-zoomed');
          var image = item.querySelector('.ap-zoom-image');
          if (image) image.style.transform = '';
        }
      });

      if (!activeZoomItem || !activeImage) return;

      if (zoomScale <= 1.01) {
        zoomScale = 1;
        zoomTranslateX = 0;
        zoomTranslateY = 0;
      }

      activeZoomItem.classList.toggle('is-zoomed', zoomScale > 1.01);
      activeImage.style.transform = 'translate3d(' + zoomTranslateX + 'px, ' + zoomTranslateY + 'px, 0) scale(' + zoomScale + ')';
    }

    function setZoomState(zoomed) {
      zoomScale = zoomed ? 2.15 : 1;
      zoomTranslateX = 0;
      zoomTranslateY = 0;
      applyZoomTransform();
    }

    function setZoomScale(scale) {
      zoomScale = clampZoomScale(scale);
      applyZoomTransform();
    }

    function openZoom(zoomed) {
      if (!zoomDialog) return;
      var activeThumb = root.querySelector('[data-ap-thumb].is-active');
      if (activeThumb) {
        setMedia(activeThumb.getAttribute('data-ap-thumb'));
      }
      zoomItems.forEach(function(item) {
        item.classList.remove('is-zoomed');
      });

      if (typeof zoomDialog.showModal === 'function') {
        zoomDialog.showModal();
      } else {
        zoomDialog.setAttribute('open', '');
      }
      zoomDialog.scrollTop = 0;
      zoomDialog.scrollLeft = 0;
      setZoomState(Boolean(zoomed));
      syncMediaControls();
    }

    function toggleZoomMedia() {
      var activeZoomItem = getActiveZoomItem();

      if (!activeZoomItem) return;
      setZoomState(!activeZoomItem.classList.contains('is-zoomed'));
    }

    function closeZoom() {
      if (!zoomDialog) return;

      if (typeof zoomDialog.close === 'function') {
        zoomDialog.close();
      } else {
        zoomDialog.removeAttribute('open');
      }
      setZoomState(false);
    }

    function getColorStartIndex(variantOption) {
      var selectedColor = colorOptionPosition > 0 ? variantOption.getAttribute('data-color-value') : '';
      var currentIndex = mediaIndexFromOption(variantOption);
      var colorStart = currentIndex;

      if (colorOptionPosition > 0 && selectedColor) {
        variants.forEach(function(option) {
          var index = mediaIndexFromOption(option);
          if (index === null) return;
          if (option.getAttribute('data-color-value') !== selectedColor) return;
          if (colorStart === null || index < colorStart) {
            colorStart = index;
          }
        });
      }

      return colorStart;
    }

    function getNextColorStartIndex(startIndex, variantOption) {
      var selectedColor = colorOptionPosition > 0 ? variantOption.getAttribute('data-color-value') : '';
      var nextIndex = null;

      variants.forEach(function(option) {
        var index = mediaIndexFromOption(option);
        if (index === null || index <= startIndex) return;
        if (colorOptionPosition > 0 && option.getAttribute('data-color-value') === selectedColor) return;
        if (nextIndex === null || index < nextIndex) {
          nextIndex = index;
        }
      });

      return nextIndex;
    }

    function showAllMedia() {
      thumbs.forEach(function(thumb) {
        thumb.classList.remove('ap-media-hidden');
      });
      mediaItems.forEach(function(item) {
        item.classList.remove('ap-media-hidden');
      });
      zoomItems.forEach(function(item) {
        item.classList.remove('ap-media-hidden');
      });
    }

    function updateNoPhotoLabel(variantOption) {
      var label = variantOption ? variantOption.getAttribute('data-no-photo-label') : '';
      if (!label) label = selectedOptions[colorOptionPosition - 1] || selectedOptions.join(' / ');

      noPhotoLabelEls.forEach(function(el) {
        el.textContent = label;
      });
    }

    function filterMediaForVariant(variantOption) {
      if (!variantOption) {
        showAllMedia();
        setMedia('');
        return;
      }

      var selectedMediaId = variantOption.getAttribute('data-media-id') || '';
      var hasVariantMedia = variantOption.getAttribute('data-has-media') === 'true';

      if (!hasVariantMedia || !selectedMediaId || selectedMediaId === noPhotoMediaId) {
        updateNoPhotoLabel(variantOption);
        thumbs.forEach(function(thumb) {
          thumb.classList.add('ap-media-hidden');
        });
        mediaItems.forEach(function(item) {
          item.classList.toggle('ap-media-hidden', item.getAttribute('data-ap-main-media') !== noPhotoMediaId);
        });
        zoomItems.forEach(function(item) {
          item.classList.toggle('ap-media-hidden', item.getAttribute('data-ap-zoom-media') !== noPhotoMediaId);
        });
        setMedia(noPhotoMediaId);
        return;
      }

      zoomItems.forEach(function(item) {
        item.classList.remove('ap-media-hidden');
      });

      var startIndex = getColorStartIndex(variantOption);
      if (startIndex === null) {
        showAllMedia();
        setMedia(selectedMediaId);
        return;
      }

      var nextIndex = getNextColorStartIndex(startIndex, variantOption);
      var endIndex = nextIndex === null ? Number.POSITIVE_INFINITY : nextIndex;

      thumbs.forEach(function(thumb) {
        var index = Number(thumb.getAttribute('data-ap-media-index'));
        thumb.classList.toggle('ap-media-hidden', index < startIndex || index >= endIndex);
      });

      mediaItems.forEach(function(item) {
        var index = Number(item.getAttribute('data-ap-media-index'));
        item.classList.toggle('ap-media-hidden', index < startIndex || index >= endIndex);
      });

      setMedia(variantOption.getAttribute('data-media-id'));
    }

    function sortColorCardsByAvailability() {
      if (!colorOptionPosition) return;
      var colorCardList = root.querySelector('.ap-color-group[data-option-position="' + colorOptionPosition + '"] .ap-color-card-list');
      if (!colorCardList) return;

      Array.prototype.slice.call(colorCardList.querySelectorAll('[data-ap-option-button]')).sort(function(first, second) {
        var firstDisabled = first.disabled || first.classList.contains('is-disabled');
        var secondDisabled = second.disabled || second.classList.contains('is-disabled');

        if (firstDisabled !== secondDisabled) {
          return firstDisabled ? 1 : -1;
        }

        return Number(first.getAttribute('data-option-sort-index') || 0) - Number(second.getAttribute('data-option-sort-index') || 0);
      }).forEach(function(card) {
        colorCardList.appendChild(card);
      });
    }

    function updateOptionButtons() {
      optionButtons.forEach(function(button) {
        var position = Number(button.getAttribute('data-option-position'));
        var index = position - 1;
        var value = button.getAttribute('data-option-value') || '';
        var active = selectedOptions[index] === value;
        var available = variants.some(function(option) {
          if (!isAvailable(option)) return false;
          if (getVariantOption(option, index) !== value) return false;

          if (colorOptionPosition > 0 && position === colorOptionPosition) {
            return true;
          }

          var testOptions = selectedOptions.slice();
          testOptions[index] = value;
          return matchesOptions(option, testOptions);
        });

        button.classList.toggle('is-selected', active);
        button.classList.toggle('is-disabled', !available);
        button.disabled = false;
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        button.setAttribute('aria-disabled', available ? 'false' : 'true');
      });

      optionLabels.forEach(function(label) {
        var position = Number(label.getAttribute('data-ap-selected-option'));
        label.textContent = selectedOptions[position - 1] || '';
      });

      updateSizeChestLabel();
      updateCoatFabricSelectionMessage();
      sortColorCardsByAvailability();
    }

    function applyVariant(selected) {
      if (!selected) return;
      var available = isAvailable(selected);
      var stockText = selected.getAttribute('data-stock-text') || '';
      var stockState = selected.getAttribute('data-stock-state') || (available ? 'in' : 'out');
      selectedOptions = getVariantOptions(selected);

      if (variantSelect) {
        variantSelect.value = selected.value;
      }

      if (hiddenVariant) {
        hiddenVariant.value = selected.value;
      }

      priceEls.forEach(function(el) {
        el.textContent = selected.getAttribute('data-price') || '';
      });

      if (compareEl && compareWrap) {
        compareEl.textContent = selected.getAttribute('data-compare') || '';
        compareWrap.classList.toggle('ap-hidden', !selected.getAttribute('data-compare'));
      }

      if (saveWrap && saveEl && discountEl) {
        saveEl.textContent = selected.getAttribute('data-save') || '';
        discountEl.textContent = selected.getAttribute('data-discount') || '';
        saveWrap.classList.toggle('ap-hidden', !selected.getAttribute('data-discount'));
      }

      if (dealBadge) {
        dealBadge.classList.toggle('ap-hidden', !available || !selected.getAttribute('data-discount'));
      }

      if (skuEls.length) {
        var sku = selected.getAttribute('data-sku') || '';
        skuEls.forEach(function(skuEl) {
          skuEl.textContent = sku;
        });
        if (skuWrap) {
          skuWrap.classList.toggle('ap-hidden', !sku);
        }
      }

      stockEls.forEach(function(el) {
        el.textContent = stockText || (available ? (AP_STRINGS.inStock || '') : (AP_STRINGS.soldOut || ''));
        setStockState(el, stockState);
      });

      if (addButton && addText) {
        addButton.disabled = !available;
        addButton.setAttribute('aria-disabled', available ? 'false' : 'true');
        addText.textContent = available ? (AP_STRINGS.addToCart || '') : (AP_STRINGS.soldOut || '');
      }
      syncGokwikBuyNowAvailability(available);

      updateOptionButtons();
      updateCoatSuitConsultation(selected);
      filterMediaForVariant(selected);

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', selected.value);
        window.history.replaceState({}, '', url.toString());
      }
    }

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        setMedia(thumb.getAttribute('data-ap-thumb'));
      });
    });

    if (mediaPrevButton) {
      mediaPrevButton.addEventListener('click', function() {
        setRelativeMedia(-1);
      });
    }

    if (mediaNextButton) {
      mediaNextButton.addEventListener('click', function() {
        setRelativeMedia(1);
      });
    }

    if (zoomOpenButton) {
      zoomOpenButton.addEventListener('click', function() {
        openZoom(false);
      });
    }

    if (zoomCloseButton) {
      zoomCloseButton.addEventListener('click', closeZoom);
    }

    if (zoomPrevButton) {
      zoomPrevButton.addEventListener('click', function() {
        setRelativeMedia(-1);
      });
    }

    if (zoomNextButton) {
      zoomNextButton.addEventListener('click', function() {
        setRelativeMedia(1);
      });
    }

    if (zoomDialog) {
      zoomDialog.addEventListener('click', function(event) {
        if (event.target === zoomDialog) {
          closeZoom();
        }
      });

      zoomDialog.addEventListener('dblclick', function(event) {
        if (event.target.closest('button')) return;
        toggleZoomMedia();
      });

      zoomDialog.addEventListener('touchstart', function(event) {
        if (!event.touches || event.touches.length === 0) return;

        if (event.touches.length === 2) {
          zoomPinchStartDistance = getTouchDistance(event.touches);
          zoomStartScale = zoomScale;
          return;
        }

        zoomTouchStartX = event.touches[0].clientX;
        zoomTouchStartY = event.touches[0].clientY;
        zoomStartTranslateX = zoomTranslateX;
        zoomStartTranslateY = zoomTranslateY;
        zoomDidPan = false;
      }, { passive: true });

      zoomDialog.addEventListener('touchmove', function(event) {
        if (!event.touches) return;

        if (event.touches.length === 2 && zoomPinchStartDistance) {
          var distance = getTouchDistance(event.touches);
          event.preventDefault();
          setZoomScale(zoomStartScale * (distance / zoomPinchStartDistance));
          return;
        }

        if (event.touches.length === 1 && zoomScale > 1.01 && zoomTouchStartX !== null && zoomTouchStartY !== null) {
          var deltaX = event.touches[0].clientX - zoomTouchStartX;
          var deltaY = event.touches[0].clientY - zoomTouchStartY;
          event.preventDefault();
          zoomTranslateX = zoomStartTranslateX + deltaX;
          zoomTranslateY = zoomStartTranslateY + deltaY;
          zoomDidPan = Math.abs(deltaX) > 4 || Math.abs(deltaY) > 4;
          applyZoomTransform();
        }
      }, { passive: false });

      zoomDialog.addEventListener('touchend', function(event) {
        var endedPinch = false;
        if (zoomPinchStartDistance && (!event.touches || event.touches.length < 2)) {
          zoomPinchStartDistance = 0;
          endedPinch = true;
        }

        if (endedPinch) return;
        if (!event.changedTouches || event.changedTouches.length !== 1) return;
        if (event.target.closest('button')) return;

        var deltaX = zoomTouchStartX === null ? 0 : event.changedTouches[0].clientX - zoomTouchStartX;
        var deltaY = zoomTouchStartY === null ? 0 : event.changedTouches[0].clientY - zoomTouchStartY;
        zoomTouchStartX = null;
        zoomTouchStartY = null;

        if (zoomScale > 1.01 && zoomDidPan) {
          zoomDidPan = false;
          return;
        }

        zoomDidPan = false;

        if (Math.abs(deltaX) > 54 && Math.abs(deltaX) > Math.abs(deltaY) * 1.25) {
          if (zoomScale > 1.01) return;
          setRelativeMedia(deltaX < 0 ? 1 : -1);
          return;
        }

        var now = Date.now();
        if (now - zoomTapLast < 320) {
          zoomTapLast = 0;
          toggleZoomMedia();
          return;
        }
        zoomTapLast = now;
      }, { passive: true });
    }

    nativeShareButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        shareProductPage(button);
      });
    });

    if (mediaWrap) {
      mediaWrap.addEventListener('dblclick', function(event) {
        if (event.target.closest('button')) return;
        openZoom(true);
      });

      mediaWrap.addEventListener('touchstart', function(event) {
        if (!event.touches) return;

        if (event.touches.length === 2) {
          mediaPinchStartDistance = getTouchDistance(event.touches);
          mediaPinchOpened = false;
          return;
        }

        if (event.touches.length !== 1) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      }, { passive: true });

      mediaWrap.addEventListener('touchmove', function(event) {
        if (!event.touches || event.touches.length !== 2 || !mediaPinchStartDistance || mediaPinchOpened) return;

        var distance = getTouchDistance(event.touches);
        if (distance - mediaPinchStartDistance > 24) {
          event.preventDefault();
          mediaPinchOpened = true;
          openZoom(true);
        }
      }, { passive: false });

      mediaWrap.addEventListener('touchend', function(event) {
        if (mediaPinchStartDistance) {
          mediaPinchStartDistance = 0;
          mediaPinchOpened = false;
          touchStartX = null;
          touchStartY = null;
          return;
        }

        if (touchStartX === null || touchStartY === null || !event.changedTouches || event.changedTouches.length !== 1) return;

        var deltaX = event.changedTouches[0].clientX - touchStartX;
        var deltaY = event.changedTouches[0].clientY - touchStartY;
        touchStartX = null;
        touchStartY = null;

        if (Math.abs(deltaX) < 12 && Math.abs(deltaY) < 12) {
          if (event.target.closest('button')) return;

          var now = Date.now();
          if (now - mediaTapLast < 320) {
            mediaTapLast = 0;
            openZoom(true);
            return;
          }
          mediaTapLast = now;
          return;
        }

        if (Math.abs(deltaX) < 45 || Math.abs(deltaX) < Math.abs(deltaY) * 1.3) return;
        setRelativeMedia(deltaX < 0 ? 1 : -1);
      }, { passive: true });
    }

    if (quantityMinusButton) {
      quantityMinusButton.addEventListener('click', function() {
        changeQuantity(-1);
      });
    }

    if (quantityPlusButton) {
      quantityPlusButton.addEventListener('click', function() {
        changeQuantity(1);
      });
    }

    if (quantityInput) {
      quantityInput.addEventListener('change', clampQuantity);
      quantityInput.addEventListener('blur', clampQuantity);
      clampQuantity();
    }

    optionButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var position = Number(button.getAttribute('data-option-position'));
        var changedIndex = position - 1;
        var nextOptions = selectedOptions.slice();
        nextOptions[changedIndex] = button.getAttribute('data-option-value') || '';
        applyVariant(findAvailableVariant(nextOptions, changedIndex));
      });
    });

    if (productForm) {
      productForm.addEventListener('submit', submitProductForm, true);
    }

    window.addEventListener('resize', queueMediaFrameSync, { passive: true });
    window.addEventListener('orientationchange', function() {
      window.setTimeout(queueMediaFrameSync, 160);
    }, { passive: true });
    // Native scrolling only. The info column scrolls independently via CSS
    // (overflow-y:auto + overscroll-behavior); hijacking the wheel event here
    // disabled inertial/smooth scrolling and caused visible scroll jank.

    if ('ResizeObserver' in window && mediaWrap) {
      var mediaFrameObserver = new ResizeObserver(queueMediaFrameSync);
      mediaFrameObserver.observe(mediaWrap.closest('.ap-gallery') || mediaWrap);
    }

    syncFloatingControlsWithBuyPanel();

    if (variantSelect) {
      variantSelect.addEventListener('change', function() {
        var selected = variantSelect.options[variantSelect.selectedIndex];
        applyVariant(selected);
      });

      applyVariant(variantSelect.options[variantSelect.selectedIndex]);
    } else {
      showAllMedia();
      setMedia('');
    }
  })();
